var map = {
	"./0-bg-2.png": 772,
	"./1-bg-2.png": 3491,
	"./10-bg-2.png": 1491,
	"./12-bg-2.png": 3600,
	"./13-bg-2.png": 9531,
	"./16-bg-2.png": 5430,
	"./18-bg-2.png": 1754,
	"./19-bg-2.png": 5258,
	"./21-bg-2.png": 3471,
	"./22-bg-2.png": 2054,
	"./23-bg-2.png": 1642,
	"./24-bg-2.png": 2828,
	"./25-bg-2.png": 5806,
	"./27-bg-2.png": 7568,
	"./28-bg-2.png": 7444,
	"./31-bg-2.png": 6778,
	"./33-bg-2.png": 1487,
	"./34-bg-2.png": 3574,
	"./36-bg-2.png": 6801,
	"./37-bg-2.png": 1146,
	"./38-bg-2.png": 9774,
	"./39-bg-2.png": 717,
	"./4-bg-2.png": 5462,
	"./40-bg-2.png": 5784,
	"./42-bg-2.png": 5373,
	"./43-bg-2.png": 1413,
	"./45-bg-2.png": 9030,
	"./46-bg-2.png": 3819,
	"./48-bg-2.png": 7456,
	"./49-bg-2.png": 1369,
	"./5-bg-2.png": 5700,
	"./51-bg-2.png": 109,
	"./52-bg-2.png": 8701,
	"./55-bg-2.png": 2612,
	"./57-bg-2.png": 7752,
	"./58-bg-2.png": 6096,
	"./59-bg-2.png": 4639,
	"./6-bg-2.png": 3802,
	"./61-bg-2.png": 2950,
	"./7-bg-2.png": 1508,
	"./8-bg-2.png": 2597,
	"./9-bg-2.png": 3266
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6870;